/**
 * MOCK form-question tags — placeholder data, not from the API.
 *
 * HIDDEN (P20M-1319): the mock list below is commented out until we have a real `form.json` example to
 * model form-linked tags on. Until then nothing fabricated reaches the UI: the tag filter's "Form tags"
 * group is length-gated so it disappears, and the survey's mock "Form tags" question (commented out in
 * survey/useSurveyMediaTags) is gone with it.
 *
 * TO RESTORE the preview: uncomment MOCK_FORM_TAGS below, drop the empty array, and uncomment the
 * concat in mediaTagsStore.setVocabulary (search for the same HIDDEN marker).
 *
 * The backend owns form-linked tags (`source: 'form_question'`, bound to a survey form's file question)
 * and auto-manages them; the FE never creates them. None exist in the seeded tenants yet, which is why
 * these stood in to show what the "Form tags" group looks like in the tag *filter*.
 *
 * Because they are fabricated they were inert: `isMockTag` disables the checkbox in TagOptionList, so
 * their fake ids could never reach `?tags=` (which would filter to nothing). Real form tags arriving
 * from the API will be selectable. They carry no `media_count` either, so no invented number was shown
 * next to them.
 *
 * TO REMOVE ENTIRELY once the backend returns real form_question tags: delete this file and the two
 * references in mediaTagsStore (MOCK_FORM_TAGS import + the concat in setVocabulary) — the isMockTag
 * gate in TagOptionList then simply never matches, and the rows become selectable on their own.
 */

// Negative so they can't collide with real tag ids, and are obvious in any payload they leak into.
// const MOCK_FORM_TAGS = [
//   'E-cigarette',
//   'Youth-appealing colors',
//   'Concealable',
//   'Youth-appealing flavors',
//   'Smart vape',
//   'Copycat product',
//   'Concept flavors',
//   'Heated tobacco product',
// ].map((name, index) => ({
//   id: -(index + 1),
//   name,
//   source: 'form_question',
//   // Non-null `form` is what paints the tag forest instead of mango — see tagPalette / isFormLinkedTag.
//   form: -1,
//   question_name: name.toLowerCase(),
//   mock: true,
// }));
const MOCK_FORM_TAGS = [];

// Kept live even while the list is empty: it is what makes a mock row inert, so it has to keep working
// the moment the list above is uncommented. With an empty list it simply never matches.
export const isMockTag = (tag) => Boolean(tag?.mock);

export default MOCK_FORM_TAGS;
